import { booleanAttribute, Component, input, OnInit, output, ViewChild } from '@angular/core';
import { CardComponent } from "src/app/components/card/card.component";
import { FormAreaComponent } from "src/app/components/form-area/form-area.component";
import { InputComponent } from "src/app/components/input/input.component";
import { TranslateModule } from '@ngx-translate/core';
import { SelectComponent } from "src/app/components/select/select.component";
import { contactsTypeOptions } from './contacts-card.constants';
import { MatSlideToggle } from "@angular/material/slide-toggle";

@Component({
  selector: 'app-contacts-card',
  standalone: true,
  imports: [
    CardComponent,
    FormAreaComponent,
    InputComponent,
    TranslateModule,
    SelectComponent,
    MatSlideToggle
],
  templateUrl: './contacts-card.component.html'
})
export class ContactsCardComponent implements OnInit {
  @ViewChild('cardComponent') cardComponent!: CardComponent;

  index = input<number>();
  totalItems = input<number>();
  control = input.required<any>();
  remove = output<void>();
  contactsTypeOptions = contactsTypeOptions;
  disabled = input(false, { transform: booleanAttribute });

  ngOnInit(): void {
    if (this.disabled()) {
      this.control().disable();
    }
  }

  isFormInvalid(): void {
    if (this.control().invalid && this.cardComponent) {
      this.cardComponent.isOpen.set(true);
    }
  }
}
